import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.palette.background.paper};
  .title-container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    margin-top: 70px;
    text-align: center;
    align-items: center;
  }
  .title {
    font-size: 1.2rem;
    color: ${({ theme }) => theme.palette.text.primary};
    display: flex;
    align-items: center;
  }
  .warning {
    color: red;
    font-size: 1rem;
    margin-bottom: -20px;
  }

  .about-container {
    font-size: 1.2rem;
    padding: 10px;
    color: ${({ theme }) => theme.palette.text.primary};
  }
  .about-icon {
    font-size: 40px;
    margin-left: 10px;
    cursor: pointer;
  }

  @media screen and (min-width: 1000px) {
    .title {
      font-size: 2rem;
    }
    .warning {
      font-size: 1.5rem;
      margin-bottom: 20px;
    }
  }
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;

  .input-container {
    margin: 10px;
  }
  .string-input {
    min-width: 235px;
    width: 235px;
  }
  .content {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 235px;
  }
  .buttons {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
  }
  .cancel {
    margin-left: 20px;
  }

  @media screen and (min-width: 1000px) {
    .string-input {
      min-width: 520px;
    }
    .content {
      width: 520px;
    }
    .cancel {
      margin-left: 50px;
    }
    .input-container {
      margin: 20px;
    }
  }
`;

export { Div, Form };
